import { WorkerForm, AuthResponse, WorkerResponse } from '../types/worker';
import { ALLOWED_FILE_TYPES, MAX_FILE_SIZE } from '../constants/worker';

const API_BASE_URL = 'https://x1lc-aku3-stjs.p7.xano.io';

export class APIError extends Error {
  constructor(message: string, public status?: number) {
    super(message);
    this.name = 'APIError';
  }
}

export const validateFile = (file: File): void => {
  if (!ALLOWED_FILE_TYPES.includes(file.type)) {
    throw new APIError('Format de fichier non supporté. PDF, Word, PNG, JPEG uniquement.');
  }
  
  if (file.size > MAX_FILE_SIZE) {
    throw new APIError('Le fichier dépasse 10MB. Merci de choisir un fichier plus léger.');
  }
};

export const createAuthAccount = async (form: WorkerForm): Promise<AuthResponse> => {
  const response = await fetch(`${API_BASE_URL}/api:O20NksVB/auth/signup`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      email: form.email,
      password: form.password,
      name: `${form.first_name} ${form.last_name}`,
    }),
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new APIError(error.message || 'Erreur lors de la création du compte.');
  }

  return response.json();
};

export const createWorkerProfile = async (
  form: WorkerForm, 
  authData: AuthResponse
): Promise<WorkerResponse> => {
  const formData = new FormData();
  
  // Add form fields
  formData.append('auth_id', authData.id);
  formData.append('first_name', form.first_name);
  formData.append('last_name', form.last_name);
  formData.append('email', form.email);
  formData.append('phone', form.phone);
  formData.append('job', form.job);
  formData.append('contracts', form.contracts.join(', '));
  formData.append('area', form.area);
  formData.append('diploma', form.diploma);
  formData.append('driver_license', form.driver_license);
  formData.append('caces', form.caces);
  formData.append('caces_type', form.caces_type);
  formData.append('other_info', form.other_info);
  formData.append('status', 'active');

  // Add file if present
  if (form.cv_classic) {
    validateFile(form.cv_classic);
    formData.append('cv', form.cv_classic, form.cv_classic.name);
  }

  const response = await fetch(`${API_BASE_URL}/api:moW4brDB/worker`, {
    method: 'POST',
    headers: { 
      Authorization: `Bearer ${authData.token}` 
    },
    body: formData,
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new APIError(error.message || 'Erreur lors de la création du profil.');
  }

  return response.json();
};